<h1 mat-dialog-title>Hoeveel credits wil je {{ data.type === 'remove' ? 'verminderen' : 'toevoegen' }}?</h1>

<div mat-dialog-content>
  <form [formGroup]="creditForm">
    <mat-form-field>
      <mat-label>Credits</mat-label>
      <input matInput type="number" formControlName="credits" min="0" step="0.1" required cdkFocusInitial />
      @if (creditForm.controls.credits.invalid) {
        <mat-error>Voer een geldig aantal credits in.</mat-error>
      }
    </mat-form-field>
    @if (pinEnabled) {
      <mat-form-field class="pin">
        <mat-label>Pincode</mat-label>
        <input
          matInput
          formControlName="pin"
          type="number"
          required
          minlength="4"
          maxlength="4"
          autocapitalize="off"
          autocomplete="one-time-code"
          #pin
        />
        <mat-hint align="end">{{ pin.value.length }} / 4</mat-hint>
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>Opmerking</mat-label>
      <input matInput type="text" autocomplete="off" formControlName="remarks" cdkFocusInitial />
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Annuleren</button>
  @if (data.type == 'add') {
    <button mat-flat-button [disabled]="!creditForm.valid" (click)="save()">Toevoegen</button>
  }
  @if (data.type == 'remove') {
    <button mat-flat-button [disabled]="!creditForm.valid" (click)="save()" class="error-button">Verminderen</button>
  }
</div>
